// 仕様: UI状態管理用のRedux Slice
// モーダル、ローディング、エラーメッセージなどのUI状態を一元管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface ModalState {
  isOpen: boolean;
  type: string | null;
  data: any;
}

interface UIState {
  loading: boolean;
  error: {
    isError: boolean;
    message: string;
  };
  modal: ModalState;
  timeout: boolean;
  apiError: boolean;
}

const initialState: UIState = {
  loading: false,
  error: {
    isError: false,
    message: '',
  },
  modal: {
    isOpen: false,
    type: null,
    data: null,
  },
  timeout: false,
  apiError: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    // ローディング状態の設定
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    // エラー状態の設定
    setError: (state, action: PayloadAction<{ isError: boolean; message: string }>) => {
      state.error = action.payload;
    },
    // エラークリア
    clearError: (state) => {
      state.error = {
        isError: false,
        message: '',
      };
    },
    // モーダルを開く
    openModal: (state, action: PayloadAction<{ type: string; data?: any }>) => {
      state.modal = {
        isOpen: true,
        type: action.payload.type,
        data: action.payload.data || null,
      };
    },
    // モーダルを閉じる
    closeModal: (state) => {
      state.modal = {
        isOpen: false,
        type: null,
        data: null,
      };
    },
    // タイムアウト状態の設定
    setTimeout: (state, action: PayloadAction<boolean>) => {
      state.timeout = action.payload;
    },
    // APIエラー状態の設定
    setApiError: (state, action: PayloadAction<boolean>) => {
      state.apiError = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  openModal,
  closeModal,
  setTimeout,
  setApiError,
} = uiSlice.actions;

// セレクター
export const selectLoading = (state: RootState) => state.ui.loading;
export const selectError = (state: RootState) => state.ui.error;
export const selectModal = (state: RootState) => state.ui.modal;
export const selectTimeout = (state: RootState) => state.ui.timeout;
export const selectApiError = (state: RootState) => state.ui.apiError;

export default uiSlice.reducer;
